import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BlockUIModule } from 'ng-block-ui';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';

import { LayoutModule } from '../../../layouts/layout.module';
import { ActionButtonModule } from '../../../../shared/action-button';
import { ContainerModule } from '../../../../shared/container';
import { ListContainerModule } from '../../../../shared/list-container';
import { TabsModule } from '../../../../shared/tabs';
import { WidgetModule } from '../../../../shared/widget';

import { MonthlyCutListComponent } from './monthly-cut-list/monthly-cut-list.component';
import { MonthlyCutNewComponent } from './monthly-cut-new/monthly-cut-new.component';
import { MonthlyCutDetailComponent } from './monthly-cut-detail/monthly-cut-detail.component';
import {
    InvestorsMonthlyCutComponent
} from './monthly-cut-detail/investors-monthly-cut/investors-monthly-cut.component';
import {
    UnitsMonthlyCutComponent
} from './monthly-cut-detail/units-monthly-cut/units-monthly-cut.component';
import { MonthlyCutRoutingModule } from './monthly-cut-routing.module';
import { UnitTableModule } from '../units/unit-table';
import { InvestorTableModule } from '../investor/investor-table';
import { FilterModule } from './../../../../shared/filter';
import { LiveSearchSelectModule } from './../../../../shared/live-search-select';
import { SelectModule } from './../../../../shared/select';
import { ModalModule } from './../../../../shared/modal';
import { DropFileModule } from './../../../../shared/drop-file';
import { ResultsTableModule } from './monthly-cut-detail/results-table';
import {
    MonthlyCutProviders, UnitProviders, InvestorProviders, InvestorMonthlyCutProviders
} from '../../../../_models';
import { TableModule } from '../../../../shared/table';
import { DatePickerModule } from '../../../../shared/date-picker';

@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        ActionButtonModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        ContainerModule,
        ListContainerModule,
        WidgetModule,
        UnitTableModule,
        InvestorTableModule,
        TabsModule,
        MonthlyCutRoutingModule,
        FilterModule,
        LiveSearchSelectModule,
        SelectModule,
        ModalModule,
        DropFileModule,
        ResultsTableModule,
        DatePickerModule,
        BlockUIModule.forRoot(),
        SweetAlert2Module.forRoot()

    ],
    declarations: [MonthlyCutListComponent, MonthlyCutNewComponent, MonthlyCutDetailComponent,
        InvestorsMonthlyCutComponent, UnitsMonthlyCutComponent
    ],
    providers: [MonthlyCutProviders, UnitProviders, InvestorProviders, InvestorMonthlyCutProviders]
})
export class MonthlyCutModule { }




// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/monthly-cut/monthly-cut.module.ts